<!-- =========================================================================================
  File Name: EditGroup.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="Group Not Found" :active.sync="errorOccurred">
      <span>Group record with id: {{ $route.params.groupId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-group'}"
                                        class="text-inherit underline">All Groups</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="group_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <group-details-tab class="mt-4" :data="group_data" v-on:update_group_data="update_group_data"/>
            </div>
          </vs-tab>
          <!---    <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
          <user-edit-tab-information class="mt-4" :data="user_data" />
            </div>
          </vs-tab> --->
          <!---  <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
          <div class="tab-text">
          <user-edit-tab-social class="mt-4" :data="user_data" />
            </div>
          </vs-tab> --->
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import GroupDetailsTab from './GroupDetailsTab.vue'


export default {
  components: {
    GroupDetailsTab
  },
  data () {
    return {
      group_data: null,
      errorOccurred: false,

      activeTab: 0
    }
  },
  methods: {
    load_group_data () {
      this.$http.get(`groups/${this.$route.params.groupId}`)
        .then(response => {
          if (response.status === 200) {
            this.group_data = {}
            this.group_data.group_id = response.data.data.id
            this.group_data.group_name = response.data.data.name
            this.group_data.group_description = response.data.data.description
            this.group_data.group_color = response.data.data.color
            this.group_data.group_status = response.data.data.status
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    update_group_data (data) {

      const pl = {
        name: data.group_name,
        description: data.group_description,
        color: data.group_color === undefined ? '#00B5FF' : data.group_color,
        status: data.group_status === undefined ? 'active' : data.group_status

      }

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update group',
          text: 'Please provide a Group Name',
          color: 'danger',
          position: 'top-right'
        })
      }


      this.$vs.loading()

      this.$http.post(`groups/${this.$route.params.groupId}`, pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Group Successfully',
              text: `Group ${pl.name} has been updated.`,
              color: 'success',
              position: 'top-right'
            })
            return this.load_group_data()
          }

        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this group'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update group',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.load_group_data(this.$route.params.groupId)
  }
}

</script>
